import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from '../global/Header';
import LoginHandler from '../util/LoginHandler/LoginHandler';
import 'themes/baseTheme/styles/global-styles.css';
import styles from './App.module.css';
import ToastWrapper from './ToastWrapper/ToastWrapper';
import Subscriptions from 'components/pages/Subscriptions/Subscriptions';
import SubscriptionLines from 'components/pages/SubscriptionLines/SubscriptionLines';
import ServiceLevelsPage from 'components/pages/ServiceLevels/ServiceLevelsPage';
import CustomSubscriptionConfigurationPage from 'components/pages/CustomSubscriptionConfiguration/CustomSubscriptionConfigurationPage';
import NotFoundPage from 'components/pages/NotFoundPage/NotFoundPage';
import type { Theme } from '@standardsdigital/ui-components/ThemeProvider';
import ThemeProvider, {
  themes,
} from '@standardsdigital/ui-components/ThemeProvider';
import { getActiveCustomer } from '../../util/util';
import Favicon from '@standardsdigital/ui-components/Favicon';
import type { Client } from '@standardsdigital/ui-components/Logo';
import { useGetAppConfigurationQuery } from 'redux/services/appConfigurationApi';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import LanguageHandler from './LanguageHandler/LanguageHandler';
import Spinner from '@/components/global/Spinner/Spinner';
import { routes } from 'util/routes';

let theme: Theme = themes.sd;
if (getActiveCustomer() in themes) {
  theme = getActiveCustomer() as Theme;
}

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;

    const handleLanguageChange = (lng: string) => {
      document.documentElement.lang = lng;
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: configuration, isLoading } = useGetAppConfigurationQuery();

  if (isLoading) {
    return <Spinner position="centerAbsolute" size="large" />;
  }

  const allowedRoles = configuration?.allowedRoles ?? [];
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ToastWrapper />
        <div className={styles.pageWrapper}>
          <Favicon clientCode={theme as Client} />
          <Header />
          <main className={styles.main}>
            <LoginHandler allowedRoles={allowedRoles}>
              <Routes>
                <Route path=":lang?/*" element={<LanguageHandler />}>
                  <Route index element={<Subscriptions />} />
                  <Route
                    path={`${routes.serviceLevels.path}/*`}
                    element={<ServiceLevelsPage />}
                  />
                  <Route
                    path={routes.configuration.path}
                    element={<CustomSubscriptionConfigurationPage />}
                  />
                  <Route
                    path={routes.subscriptionLines.path}
                    element={<SubscriptionLines />}
                  />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Routes>
            </LoginHandler>
          </main>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
